var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar"},[_c('el-alert',{attrs:{"title":"Calendario no disponible","type":"info","closable":false,"description":"Este tipo de porlet (Calendar) ya no está soportado. Use el porlet Calendario en su lugar.","show-icon":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }